export const USER_ROLES = {
  TRADER: 'trader',
  PARTNER: 'partner',
  MANAGER: 'manager',
} as const;
